import { appState } from "../redux/redux-config";
import { language as languageApi } from "../api/language-api";

const language = {
    getLanguages: async function () {
        let token = appState().user.token;
        return languageApi.getLanguages(token);
    },

    translateText: async function (text, targetLanguage) {
        let token = appState().user.token;
        return languageApi.translateText(token, text, targetLanguage);
    },
};

export default language;
